// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:39:23

export default {
  "id": "world-flags-trivia",
  "slug": "world-flags-trivia",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9532b5f88d9a4ffe94832b29294e5484-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9532b5f88d9a4ffe94832b29294e5484/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "World Flags Trivia",
      "description": "Challenge your geography skills in World Flags Trivia! Identify the nation for each flag from three choices across 194 questions. Perfect your skills as you progress through increasingly tricky questions. Can you score a perfect game and become a true flag expert? Play now and find out!",
      "instructions": "Use a mouse or touchpad to play this game.",
      "genres": [
        "Educational",
        "Puzzle"
      ],
      "tags": [
        "challenge",
        "flags",
        "geography",
        "thinking",
        "trivia"
      ]
    },
    "zh-CN": {
      "title": "世界国旗知识问答",
      "description": "在《世界国旗知识问答》中挑战你的地理知识！从三个选项中识别每面国旗所属的国家，共有194个问题。随着你进步到越来越难的题目，磨练你的技能。你能获得满分，成为真正的国旗专家吗？现在就玩起来，看看答案吧！",
      "instructions": "使用鼠标或触摸板来玩这款游戏。",
      "genres": [
        "教育",
        "益智"
      ],
      "tags": [
        "挑战",
        "旗帜",
        "地理",
        "思考",
        "知识问答"
      ]
    },
    "zh-TW": {
      "title": "世界旗幟知識小遊戲",
      "description": "挑戰你的地理知識在《世界旗幟猜國家遊戲》！從三個選項中辨識每面旗幟代表的國家，共194題問題。隨著進度增加挑戰性，逐步精進你的技能。你能得分滿分，成為真正的旗幟專家嗎？現在就開始遊戲，一探究竟！",
      "instructions": "使用滑鼠或觸控板來玩這款遊戲。",
      "genres": [
        "教育性",
        "謎題"
      ],
      "tags": [
        "挑戰",
        "旗幟",
        "地理",
        "思考",
        "趣味問答"
      ]
    },
    "zh-HK": {
      "title": "世界旗幟知識問答遊戲",
      "description": "挑戰你的地理知識在《世界旗幟猜猜猜》！從三個選項中識別每面旗幟屬於哪個國家，共有194題。隨著進行，挑戰越來越難的題目，完善你的技巧。你能得分全滿，成為真正的旗幟專家嗎？現在就玩遊戲，找出答案吧！",
      "instructions": "使用滑鼠或觸控板來玩這款遊戲。",
      "genres": [
        "教育性",
        "謎題"
      ],
      "tags": [
        "挑戰",
        "旗幟",
        "地理",
        "思考",
        "趣味問答"
      ]
    },
    "ja": {
      "title": "世界旗のクイズ",
      "description": "世界の国旗に関する知識を試してみてください！194の問題の中から、各国旗に対応する国を選んでください。難易度が段階的に上がる問題を通じて、あなたのスキルを磨いてください。完璧なスコアを獲得し、真の国旗の専門家に輝けるかどうか、今すぐプレイして見てください！",
      "instructions": "マウスやタッチパッドを使用してこのゲームをプレイしてください。",
      "genres": [
        "教育用",
        "パズル"
      ],
      "tags": [
        "挑戦",
        "旗",
        "地理",
        "思考",
        "クイズ"
      ]
    },
    "ko": {
      "title": "세계기호 트라이비아",
      "description": "World Flags Trivia에서 지리 지식을 도전하세요! 194개의 질문에서 각 국기에 대한 나라를 세 가지 선택肢에서辨识해 보세요. 점진적으로 어려워지는 질문을 통해 자신의 능력을 완성하세요. 완벽한 스코어를 맞추고 진정한 국기 전문가가 될 수 있을까요? 지금 플레이하고 알아보세요!",
      "instructions": "이 게임을 플레이하려면 마우스나 타ッチ패드를 사용하세요.",
      "genres": [
        "교육적",
        "퍼즐"
      ],
      "tags": [
        "挑戦",
        "기호",
        "지리학",
        "사고력",
        "트라이비"
      ]
    },
    "fr": {
      "title": "Drapeaux du Monde Questions de Culture Générale",
      "description": "Défiez vos compétences en géographie dans World Flags Trivia ! Identifiez le pays pour chaque drapeau parmi trois choix au cours de 194 questions. Affinez vos compétences en progressant à travers des questions de plus en plus difficiles. Pouvez-vous obtenir un score parfait et devenir un véritable expert des drapeaux ? Jouez maintenant et le découvrez !",
      "instructions": "Utilisez une souris ou un pavé tactile pour jouer à ce jeu.",
      "genres": [
        "Éducatif",
        "Puzzle"
      ],
      "tags": [
        "défis",
        "drapeaux",
        "géographie",
        "réflexion",
        "trivia"
      ]
    }
  }
};
